
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Link } from 'react-router-dom';

export interface Tour {
  id: string | number;
  titleEn: string;
  titleHe: string;
  descriptionEn: string;
  descriptionHe: string;
  image: string;
  duration: number;
  exhibits: number[] | string[];
  exhibitCount?: number; // Added as optional for backward compatibility
  mapType: 'indoor' | 'outdoor';
  mapImage?: string;
}

interface TourCardProps {
  tour: Tour;
}

const TourCard = ({ tour }: TourCardProps) => {
  const { language } = useLanguage();
  
  
  // Use exhibitCount if available, otherwise fall back to length of exhibits array
  const exhibitCount = tour.exhibitCount !== undefined ? 
    tour.exhibitCount : 
    (Array.isArray(tour.exhibits) ? tour.exhibits.length : 0);
  
  return (
    <Link to={`/tours/${tour.id}`} className="museum-card block relative group">
      <div className="relative h-48 overflow-hidden rounded-t-xl">
        <img 
          src={tour.image} 
          alt={language === 'en' ? tour.titleEn : tour.titleHe} 
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>
      <div className="bg-white px-4 py-3 rounded-b-xl">
         <h3 className="font-display font-bold text-xl text-gray-900 leading-tight mb-1 whitespace-pre-line">
           {language === 'en' ? tour.titleEn : tour.titleHe}
         </h3>
        <span className="text-sm font-semibold text-gray-600">
          {exhibitCount} {language === 'en' ? 'exhibits' : 'מוצגים'}
        </span>
      </div>
      <div className="p-4 pt-0">
        <p className="text-gray-600 mb-3 line-clamp-3">
          {language === 'en' ? tour.descriptionEn : tour.descriptionHe}
        </p>
      </div>
    </Link>
  );
};

export default TourCard;
